import { usePrivacy } from '../context/PrivacyContext';

// Wraps any sensitive figure (production $, policy counts, comp levels). Blurs when privacy mode is on.
export const Sensitive = ({ children, as: Tag = 'span', className = '', ...rest }) => {
  const { hidden } = usePrivacy();
  return (
    <Tag
      {...rest}
      className={`${className} transition-[filter] duration-200 ${hidden ? 'blur-[7px] select-none pointer-events-none' : ''}`}
      aria-hidden={hidden || undefined}
      data-sensitive={hidden ? 'hidden' : 'visible'}
    >
      {children}
    </Tag>
  );
};
